import { render } from "./OrderPage.vue?vue&type=template&id=4b3d2274"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"

import "@/css/OrderPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__